var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 3.57746e-08L24 3.2608L12 16L3.88847e-08 3.2608L3 2.50422e-07L12 9.6L21 3.57746e-08Z","fill":"currentColor"}));
}

Down.defaultProps = {"viewBox":"0 0 24 16","fill":"none","style":{"color":"#878D90"}};

module.exports = Down;

Down.default = Down;
